import React from "react";
import cn from "classnames";
import css from "./Panel.module.css";

type Props = {
    paddingTop?: "40px" | "20px";
    className?: string;
};

export const Panel: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    paddingTop,
    className,
}) => {
    return (
        <div className={cn(css.main, className)} style={{ paddingTop }}>
            {children}
        </div>
    );
};
